<script lang="ts">
	import { handleUserGivenRating, postReq } from 'src/services/http';
	import { Button, Text } from '@Shelly/shelly-design-system';
	import { showAndroidRateAppPopUp } from 'src/services/native_container_requests_android';
	import { get } from 'svelte/store';
	import { app } from 'src/stores/session/native-bridge';

	const isApp = get(app);
	let result = '';

	const handleRateShowReset = async () => {
		const res = await handleUserGivenRating({
			ios: {
				show: true,
				condition: 'reset',
				ts: Date.now(),
				userAction: 'close',
			},
			android: {
				show: true,
				condition: 'reset',
				ts: Date.now(),
				userAction: 'close',
			},
		});
		console.log('rate is reset', res);
	};

	const showRateAppPopUp = async (command) => {
		const res = await showAndroidRateAppPopUp(command);
		result = JSON.stringify(res);
	};

	const resetUserCampaigns = async () => {
		const data = [
			{
				id: 'xmass_2025',
				ts: 1765353600,
			},
		];

		await postReq('/interface/home/save', {
			id: 'ar_campaigns',
			data: JSON.stringify(data),
		});

		result = 'User campaigns have been reset.';
	};
</script>

<Button class="mb-m" variant="secondary" icon="fas fa-star" on:click={handleRateShowReset}>
	Reset all rating data for current platform
</Button>

<!-- {#if isApp} -->
<Button
	class="mb-m"
	variant="secondary"
	on:click={() => {
		showRateAppPopUp('inAppReview');
	}}
>
	Show modal with InAppReview command
</Button>
<Button
	class="mb-m"
	variant="secondary"
	on:click={() => {
		showRateAppPopUp('detailsPage');
	}}
>
	Show modal with detailsPage command
</Button>

<Button
	class="mb-m"
	variant="secondary"
	on:click={() => {
		resetUserCampaigns();
	}}
>
	Reset Campaigns
</Button>

<Text>Result:</Text>
<Text>
	{result}
</Text>
<!-- {/if} -->
